import { NgModule } from '@angular/core';
import { NgxFullpageGoToSectionDirective } from './just-fullpage-go-to-section/ngx-fullpage-go-to-section.directive';



@NgModule({
  declarations: [NgxFullpageGoToSectionDirective],
  imports: [],
  exports: [NgxFullpageGoToSectionDirective],
})
export class NgxFullpageGoToSectionModule { }
